/* global mixpanel */
import { put, select, call } from 'redux-saga/effects'
import * as actions from '../action_creators'
import * as client from '../../api/client'
import { getProfileId, getHorizon, getProfile } from '../selectors'
import { handleFetchTimeEntries } from './time_entries_sagas'
import { handleCreateGoal, handleUpdateGoal, handleDeleteGoal } from './goal_sagas'
import { makeToast } from '../../util/toast_util'
import GA from "react-ga"

export function* getRecentTagCombos() {
    try {
        const resp = yield call(client.getRecentTagCombos)
        if (resp === undefined) return
        yield put(actions.receiveRecentTagCombos(resp))
    } catch (e) {
        return
    }
}

export function* getRecentTags({ params }) {
    const ownerId = yield select(getProfileId)
    const { start, end } = params
    const queryParams = {
        startsBy: start,
        endsBy: end,
        ownerId,
    }

    try {
        const resp = yield call(client.getRecentTags, queryParams)
        if (resp === undefined) return
        yield put(actions.receiveRecentTags(resp))
    } catch (e) {
        const errorMsg = "Failed to fetch recent tags"
        console.log(errorMsg + ", error: ", e) // eslint-disable-line no-console
        yield call(makeToast, errorMsg, "danger")
    }
}

function createGoal(tagId, goal) {
    goal.tags = [{ tagId }]
    goal.users = []
    goal.startDate = new Date().getTime() / 1000
}

export function* handleCreateTag({ tag, goal }) {
    try {
        // 1. create the tag
        const resp = yield call(client.postTag, tag)
        yield put(actions.receiveTag(resp))

        // toast if onboarding complete
        const { onboardingStep } = yield select(getProfile)
        if (onboardingStep === "done") {
            const msg = `Tag ${tag.name} created.`
            const ind = "success"
            yield call(makeToast, msg, ind)
        }

        // 2. create or update the goal
        const tagId = resp.id
        if (goal) {
            if (goal.id) {
                // hmm... this shouldn't happen on create tag!
                console.log("** ERR? ** creating a tag with a non-new goal! ignoring goal", goal) // eslint-disable-line no-console
            } else {
                createGoal(tagId, goal)
                yield call(handleCreateGoal, { goal } )
            }
        }
        const { teamId, name } = tag
        mixpanel.track("Tag created", { tagId, teamId, name })
        GA.event({category: "User", action: "Tag created"})
    }
    catch(e) {
        yield call(makeToast, 'Something went wrong creating tag', 'warning')
        return
    }
}

export function* handleUpdateTag({ tag, goal, deleteGoal }) {
    try {
        // 1. update the tag
        const resp = yield call(client.putTag, tag)
        yield put(actions.receiveTag(resp))
        // toast
        const msg = `Tag ${tag.name} updated.`
        const ind = "success"
        yield call(makeToast, msg, ind)

        // 2. create or update the goal
        if (goal) {
            if (goal.id) {
                const goalAction = deleteGoal
                    ? handleDeleteGoal
                    : handleUpdateGoal
                yield call(goalAction, { goal })
            } else {
                createGoal(tag.id, goal)
                yield call(handleCreateGoal, { goal })
            }
        }
    }
    catch(e) {
        yield call(makeToast, 'Something went wrong updating the tag', 'warning')
        return
    }

}

export function* handleDeleteTag({ tag }) {
    const tagName = tag.name
    try {
        // toast
        yield call(client.deleteTag, tag)
        const msg = `"${tagName}" has been deleted.`
        const ind = "green"
        yield call(makeToast, msg, ind)
        yield put(actions.removeTag(tag))
    }
    catch(e) {
        yield call(makeToast, 'Something went wrong deleting the tag', 'warning')
        return
    }

    const horizon = yield select(getHorizon, 'viewport')
    yield call(handleFetchTimeEntries, { params: horizon })
}

export function* handleFetchTags({ params }) {
    try {
        const resp = yield call(client.getTags, null, params)
        if (resp === undefined) return
        yield put(actions.receiveTags(resp))
    } catch (e) {
        return
    }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/tag_sagas.js